import { MotionConfig } from 'framer-motion'
import React from 'react'

export const wrapPageElement = ({element}) => (
  <MotionConfig reducedMotion="user">{element}</MotionConfig>
);